import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';




import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';


import PrivacyPolicy from './components/privacy';
import Impressum from './components/impressum';
import Hero from './components/hero';
import MainNavbar from './components/navbar';
import StoriesCarousel from './components/StoriesCarousel';
import ServicesCards from './components/services';
import ServiceAreaBanner from './components/serviceAreaBanner';
import StatsBanner from './components/statsBanner';
import Footer from './components/footer';
import CookieConsent from './components/cookiebanner';
import PriceList from './components/PriceList';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.querySelector(location.state.scrollTo);
      if (el) {
        // Delay slightly to allow rendering
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <StoriesCarousel />
      <StatsBanner />
      <ServicesCards />
      <PriceList />
      <ServiceAreaBanner />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <MainNavbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impresszum" element={<Impressum />} />
          <Route path="/adatvedelem" element={<PrivacyPolicy />} />
        </Routes>
        <CookieConsent />
        <Footer />

      </div>
    </Router>
  );
}

export default App;
